import templateUrl from 'emun.on-demand/shopping/shopping-add-design-to-cart.htm'
import ShopController from 'emun.shopping/shop.controller'
import ProductListPicker from 'emun.products/lists/product-list-picker'

class AddDesignToCartController extends ShopController {
    constructor($cart) {
        super($cart)
    }
    $onInit() {
    }
    add(cartId) {
    }

    addToList() {
        ProductListPicker.open({ product: this.oneUp.product });
    }
    canLogin() {
    }
    canAdd() {
        return this.$session.isAuthenticated || this.$session.businessModel === 'Retail';
    }
}

let AddDesignToCart = {
    require: {
        oneUpDesigner: '^shoppingOneUpDesigner',
        oneUp: '^shoppingOneUp'
    },
    bindings: {
        //product: '<',
        //designer: '<',
        disabled: '<?'
    },
    controller: AddDesignToCartController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
}

export default AddDesignToCart;